/**
 * This file is specifically for rule engine api
 */
import makeHttpRequest from '../helpers/ajax';

export default {
    getAPIurl() {
        return WP_RULEENGINE_URL;
    },
    getDMACalculations(path, dataInputs, callBackFunction) {
        if (!dataInputs) {
            return 'Error: no data passed';
        }
        if (typeof callBackFunction != 'function') return false;
        this.callBackFunction = callBackFunction;

        let url = this.getAPIurl();
        url += path;
        url += Object.entries(dataInputs).map(e => e.join('=')).join('&');

        return makeHttpRequest({ url }).then((response) => {
            const json = JSON.parse(response);
            this.callBackFunction(json);
        }, () => {
            this.callBackFunction({});
            console.warn('There is some issue with network call, please try again');
        });
    },
};
